(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.queue = Promise.resolve();
      this.pending = 0;
      this.opener = null;
      this.state = this.readState(this);

      window.BarkitaCart = {
        open: () => this.open(),
        close: () => this.close(),
        refresh: () => this.refresh(),
        add: (items) => this.add(items),
        get state() {
          return this.drawer.state;
        },
        drawer: this
      };

      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keydown', (event) => this.onKeydown(event));

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cart-open]');

        if (!trigger) return;

        event.preventDefault();
        this.opener = trigger;
        this.open();
      });

      window.addEventListener(
        'submit',
        (event) => {
          const form = event.target;

          if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-form]')) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.addFromForm(form);
        },
        true
      );

      document.addEventListener('cart:refresh', () => this.refresh());
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.refresh();
      });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.refresh();
      });

      this.updateHeaderCount();
      this.enqueue(() => this.reconcile());
    }

    readState(root) {
      const script = root.querySelector('script[data-cart-state]');

      try {
        return script ? JSON.parse(script.textContent) : null;
      } catch (error) {
        return null;
      }
    }

    /* Opening and closing */

    open() {
      if (this.classList.contains('is-open')) return;

      this.restoreInert = [];

      Array.from(document.body.children).forEach((element) => {
        if (element.contains(this)) return;

        if (!element.inert) {
          element.inert = true;
          this.restoreInert.push(element);
        }
      });

      document.documentElement.classList.add('cart-drawer-open');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.querySelector('.cart-drawer__panel').focus({ preventScroll: true });
      });
    }

    close() {
      if (!this.classList.contains('is-open')) return;

      this.classList.remove('is-open');
      document.documentElement.classList.remove('cart-drawer-open');
      (this.restoreInert || []).forEach((element) => {
        element.inert = false;
      });
      this.restoreInert = [];

      if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();

        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        this.querySelectorAll('button:not([disabled]), a[href]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.querySelector('.cart-drawer__panel'))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    onClick(event) {
      if (event.target.closest('[data-cart-close]')) {
        this.close();

        return;
      }

      const step = event.target.closest('[data-qty-step]');
      const remove = event.target.closest('[data-remove]');
      const line = event.target.closest('[data-line-key]');

      if (!line || line.dataset.lineType === 'gift') return;

      if (step) {
        const quantity = Number(step.dataset.quantity) + Number(step.dataset.qtyStep);

        this.changeLine(line.dataset.lineKey, Math.max(0, quantity), step.dataset.qtyStep);
      } else if (remove) {
        this.changeLine(line.dataset.lineKey, 0, 'remove');
      }
    }

    /* Requests (serialized) */

    enqueue(task) {
      this.pending += 1;
      this.setAttribute('aria-busy', 'true');

      const run = this.queue.then(task).catch((error) => {
        this.showError(error);
      });

      this.queue = run.then(() => {
        this.pending -= 1;

        if (this.pending === 0) this.removeAttribute('aria-busy');
      });

      return this.queue;
    }

    async post(endpoint, body) {
      const response = await fetch(`${window.Shopify.routes.root}cart/${endpoint}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await response.json();

      if (!response.ok) {
        const error = new Error(data.description || data.message || 'cart error');

        error.status = response.status;
        throw error;
      }

      return data;
    }

    async fetchSection() {
      const response = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer&t=${Date.now()}`, {
        headers: { Accept: 'application/json' }
      });
      const data = await response.json();

      return data['cart-drawer'];
    }

    async add(items) {
      this.open();

      return this.enqueue(async () => {
        const data = await this.post('add', { items });

        this.render(data.sections['cart-drawer']);
        await this.reconcile();
      });
    }

    addFromForm(form) {
      const data = new FormData(form);
      const purchase = form.closest('product-purchase');
      const item = { id: Number(data.get('id')), quantity: Math.max(1, Number(data.get('quantity')) || 1) };
      const plan = purchase ? purchase.dataset.sellingPlanId : '';

      if (purchase && purchase.dataset.purchaseOption === 'subscription' && plan) {
        item.selling_plan = Number(plan);
      }

      this.opener = document.activeElement;

      return this.add([item]);
    }

    changeLine(key, quantity, action) {
      const line = this.querySelector(`[data-line-key="${CSS.escape(key)}"]`);

      if (line && quantity > 0) {
        const value = line.querySelector('.cart-qty__value');

        if (value) value.textContent = quantity;
      } else if (line) {
        line.classList.add('is-leaving');
        window.setTimeout(() => line.remove(), 340);
      }

      this.focusTarget = action === 'remove' ? null : { key, action };

      return this.enqueue(async () => {
        try {
          const data = await this.post('change', { id: key, quantity });

          this.render(data.sections['cart-drawer']);
        } catch (error) {
          this.render(await this.fetchSection());
          throw error;
        }

        await this.reconcile();
      });
    }

    refresh() {
      return this.enqueue(async () => {
        this.render(await this.fetchSection());
        await this.reconcile();
      });
    }

    /* Gift reconciliation: the gifts exist if and only if the promotion is achieved */

    planGifts(state) {
      const updates = {};
      const items = [];
      const retag = (state.stale || []).slice();

      (state.gifts || []).forEach((gift) => {
        const lines = gift.lines || [];
        const target = state.giftTarget === undefined ? 1 : state.giftTarget;

        if (state.achieved && target > 0) {
          if (!lines.length) {
            items.push({ id: gift.variantId, quantity: target, properties: { _promo_gift: 'snacks-promo' } });

            return;
          }

          if (lines[0].quantity !== target) updates[lines[0].key] = target;

          lines.slice(1).forEach((line) => {
            updates[line.key] = 0;
          });
        } else {
          lines.forEach((line) => {
            updates[line.key] = 0;
          });
        }
      });

      return { updates, items, retag };
    }

    async reconcile() {
      for (let pass = 0; pass < 3; pass += 1) {
        const state = this.state;

        if (!state) return;

        const plan = this.planGifts(state);
        const hasUpdates = Object.keys(plan.updates).length > 0;

        if (!hasUpdates && !plan.items.length && !plan.retag.length) return;

        /* Old gift lines (still carrying _promo_gift) of a product that is no longer a gift: keep the
           line and its quantity as a regular purchase, only drop the marker. Regular lines never have it. */
        if (plan.retag.length) {
          let data = null;

          for (const line of plan.retag) {
            data = await this.post('change', { id: line.key, quantity: line.quantity, properties: { _promo_gift: '' } });
          }

          this.render(data.sections['cart-drawer']);

          continue;
        }

        if (hasUpdates) {
          const data = await this.post('update', { updates: plan.updates });

          this.render(data.sections['cart-drawer']);
        }

        if (plan.items.length) {
          const data = await this.post('add', { items: plan.items });

          this.render(data.sections['cart-drawer']);
        }
      }
    }

    /* Rendering: patches the existing DOM so that every change can be animated */

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('cart-drawer');

      if (!next) return;

      this.state = this.readState(next);
      this.dataset.state = next.dataset.state;

      const script = this.querySelector('script[data-cart-state]');
      const nextScript = next.querySelector('script[data-cart-state]');

      if (script && nextScript) script.textContent = nextScript.textContent;

      this.patchPromo(next);
      this.patchLines(next);
      this.patchFooter(next);
      this.updateHeaderCount();
      this.restoreFocus();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: this.state }));
    }

    patchPromo(next) {
      const message = this.querySelector('[data-promo-message]');
      const nextMessage = next.querySelector('[data-promo-message]');

      if (message && nextMessage && message.innerHTML.trim() !== nextMessage.innerHTML.trim()) {
        message.classList.add('is-changing');
        window.setTimeout(() => {
          message.innerHTML = nextMessage.innerHTML;
          message.classList.remove('is-changing');
        }, 160);
      }

      const progress = this.querySelector('[data-promo-progress]');
      const nextProgress = next.querySelector('[data-promo-progress]');

      if (progress && nextProgress) {
        progress.style.setProperty('--progress', nextProgress.style.getPropertyValue('--progress'));
        progress.setAttribute('aria-valuenow', nextProgress.getAttribute('aria-valuenow'));
      }
    }

    patchLines(next) {
      const list = this.querySelector('[data-cart-lines]');
      const nextList = next.querySelector('[data-cart-lines]');

      if (!list || !nextList) return;

      const current = new Map();

      Array.from(list.children).forEach((line) => {
        if (!line.classList.contains('is-leaving')) current.set(line.dataset.lineKey, line);
      });

      const nextLines = Array.from(nextList.children);
      const keep = new Set(nextLines.map((line) => line.dataset.lineKey));

      current.forEach((line, key) => {
        if (keep.has(key)) return;

        line.classList.add('is-leaving');
        window.setTimeout(() => line.remove(), 340);
      });

      let previous = null;

      nextLines.forEach((nextLine) => {
        const key = nextLine.dataset.lineKey;
        let line = current.get(key);

        if (line) {
          const row = line.querySelector('.cart-line__row');
          const nextRow = nextLine.querySelector('.cart-line__row');

          if (row && nextRow && row.innerHTML !== nextRow.innerHTML) row.innerHTML = nextRow.innerHTML;
        } else {
          line = nextLine.cloneNode(true);
          line.classList.add('is-entering');
          list.appendChild(line);
          requestAnimationFrame(() => requestAnimationFrame(() => line.classList.remove('is-entering')));
        }

        const anchor = previous ? previous.nextElementSibling : list.firstElementChild;

        if (anchor !== line) list.insertBefore(line, anchor);

        previous = line;
      });
    }

    patchFooter(next) {
      const footer = this.querySelector('[data-region="footer"]');
      const nextFooter = next.querySelector('[data-region="footer"]');

      if (!footer || !nextFooter) return;

      const total = footer.querySelector('.cart-total');
      const nextTotal = nextFooter.querySelector('.cart-total');

      if (total && nextTotal && total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;

      const button = footer.querySelector('button[name="checkout"]');
      const nextButton = nextFooter.querySelector('button[name="checkout"]');

      if (button && nextButton) button.disabled = nextButton.disabled;
    }

    restoreFocus() {
      if (!this.focusTarget) return;

      const { key, action } = this.focusTarget;
      const button = this.querySelector(`[data-line-key="${CSS.escape(key)}"] [data-qty-step="${action}"]`);

      this.focusTarget = null;

      if (button && this.classList.contains('is-open')) button.focus({ preventScroll: true });
    }

    updateHeaderCount() {
      if (!this.state) return;

      const count = this.state.productCount || 0;

      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = count > 99 ? '99+' : String(count);
        badge.hidden = count === 0;
      });

      if (!this.state.cartLabel) return;

      document.querySelectorAll('[data-cart-open]').forEach((element) => {
        element.setAttribute('aria-label', this.state.cartLabel);
      });
    }

    showError(error) {
      console.error(error);

      const body = this.querySelector('.cart-drawer__body');

      if (!body) return;

      let box = this.querySelector('.cart-drawer__error');

      if (!box) {
        box = document.createElement('p');
        box.className = 'cart-drawer__error type-body';
        box.setAttribute('role', 'alert');
        body.prepend(box);
      }

      box.textContent = error && error.message ? error.message : '';
      window.clearTimeout(this.errorTimer);
      this.errorTimer = window.setTimeout(() => box.remove(), 5000);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
  class SnackCycle extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.comparison__slide'));

      /* Each bag is tied to its slide by the slide id (same block), never by its position */
      const bags = Array.from((this.closest('.comparison') || document).querySelectorAll('.comparison__bags .comparison__bag'));
      this.bags = this.slides.map((slide) => bags.find((bag) => bag.dataset.slideId === slide.dataset.slideId) || null);
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.visible = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.slides.length < 2) return;

      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[entries.length - 1].isIntersecting;

        if (this.visible) this.loadImages();

        this.update();
      });
      this.observer.observe(this);

      this.onVisibility = () => this.update();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.reduceMotion.addEventListener('change', this.onVisibility);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearInterval(this.timer);
      clearTimeout(this.leaveTimer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.reduceMotion) this.reduceMotion.removeEventListener('change', this.onVisibility);
    }

    loadImages() {
      this.loadSlide(this.index);
      this.loadSlide(this.index + 1);
    }

    /* Deferred photos (data-src) start loading one slide ahead; advance() waits until the next one is ready */
    loadSlide(index) {
      const slide = index % this.slides.length;

      [this.slides[slide], this.bags[slide]].forEach((element) => {
        const image = element && element.querySelector('img');

        if (!image) return;

        if (image.dataset.src) {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        }

        image.loading = 'eager';
      });
    }

    /* A slide is ready when its photo and its bag are loaded: they always change together */
    isReady(index) {
      return [this.slides[index], this.bags[index]].every((element) => {
        const image = element && element.querySelector('img');

        return !image || (image.complete && image.naturalWidth > 0);
      });
    }

    /* The one place where the active slide changes: photo, bag and aria state all follow `next` */
    show(next) {
      const current = this.index;

      [[this.slides[current], this.bags[current]], [this.slides[next], this.bags[next]]].forEach((pair, position) => {
        pair.forEach((element) => {
          if (!element) return;

          element.classList.toggle('is-active', position === 1);
          element.classList.toggle('is-leaving', position === 0);

          if (position === 1) element.removeAttribute('aria-hidden');
          else element.setAttribute('aria-hidden', 'true');
        });
      });

      this.index = next;
    }

    update() {
      clearInterval(this.timer);
      this.timer = null;

      if (!this.visible || document.hidden || this.reduceMotion.matches) return;

      const interval = Number(this.dataset.interval) || 2500;

      this.timer = setInterval(() => this.advance(), interval);
    }

    advance() {
      const next = (this.index + 1) % this.slides.length;
      const leaving = [this.slides[this.index], this.bags[this.index]];

      this.loadSlide(next);

      if (!this.isReady(next)) return;

      clearTimeout(this.leaveTimer);
      this.slides.concat(this.bags).forEach((element) => element && element.classList.remove('is-leaving'));

      this.show(next);
      this.loadSlide(next + 1);

      const duration = parseFloat(getComputedStyle(this).getPropertyValue('--comparison-slide-duration')) || 700;

      this.leaveTimer = setTimeout(() => leaving.forEach((element) => element && element.classList.remove('is-leaving')), duration + 50);
    }
  }

  if (!customElements.get('snack-cycle')) {
    customElements.define('snack-cycle', SnackCycle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-content"] && !Shopify.designMode) return;
  try {
    
  /* Pill buttons that swap the photo of the featured content section */
  class FeatureSwitcher extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const button = event.target.closest('[data-feature-index]');

        if (button && this.contains(button)) this.select(button.dataset.featureIndex);
      };

      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    select(index) {
      this.querySelectorAll('[data-feature-index]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.featureIndex === index));
      });

      this.querySelectorAll('[data-feature-image]').forEach((image) => {
        image.classList.toggle('is-active', image.dataset.featureImage === index);
      });
    }
  }

  if (!customElements.get('feature-switcher')) {
    customElements.define('feature-switcher', FeatureSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* "Cookie preferences" link: reopens Shopify's consent preferences when the banner API is available */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cookie-preferences]');

    if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;

    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');

      if (!this.section) return;

      this.header = this.parentElement;
      this.lastY = Math.max(0, window.scrollY);
      this.travel = 0;
      this.hidden = false;
      this.ticking = false;

      this.onScroll = () => {
        if (this.ticking) return;

        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      };

      this.onFocus = () => this.setHidden(false);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.section.addEventListener('focusin', this.onFocus);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);

      if (this.section) this.section.removeEventListener('focusin', this.onFocus);
    }

    update() {
      const y = Math.max(0, window.scrollY);
      const delta = y - this.lastY;
      const previous = this.section.previousElementSibling;
      const naturalTop = previous ? previous.offsetTop + previous.offsetHeight : 0;
      const naturalEnd = naturalTop + this.section.offsetHeight;

      this.lastY = y;

      if (y <= naturalEnd || this.isPinned()) {
        this.travel = 0;
        this.setHidden(false);

        return;
      }

      if (delta === 0) return;

      if (Math.sign(delta) !== Math.sign(this.travel)) this.travel = 0;

      this.travel += delta;

      if (this.travel > 10) {
        this.setHidden(true);
      } else if (this.travel < -10) {
        this.setHidden(false);
      }
    }

    /* A page can keep the header on screen while an element marked `data-header-pin` is still stuck right
       under it (the sticky desktop gallery of the pack page). The pin ends as soon as that element moves up,
       and an element that is not displayed (e.g. on mobile) never pins. */
    isPinned() {
      if (this.pin === undefined) this.pin = document.querySelector('[data-header-pin]');
      if (!this.pin || !this.pin.offsetParent) return false;

      return this.pin.getBoundingClientRect().top >= this.header.offsetHeight - 1;
    }

    setHidden(hidden) {
      if (hidden === this.hidden) return;

      this.hidden = hidden;
      this.section.classList.toggle('is-header-hidden', hidden);
      this.header.inert = hidden;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductPurchase extends HTMLElement {
    connectedCallback() {
      /* Sold out: the buttons are disabled in the HTML; this also keeps any other submit path (script, Enter)
         away from the cart drawer, which only handles forms marked with data-cart-form */
      if (this.hasAttribute('data-sold-out')) {
        const soldOutForm = this.querySelector('form');

        if (soldOutForm) {
          soldOutForm.removeAttribute('data-cart-form');
          soldOutForm.addEventListener('submit', (event) => event.preventDefault());
        }
      }

      this.addEventListener('change', (event) => {
        if (event.target.matches('input[name="purchase_option"]')) this.update();
        if (event.target.matches('[data-quantity-input]')) this.updatePrices(event.target.value);
      });

      this.update();
    }

    /* Individual snacks: the displayed purchase option prices are the unit prices times the quantity.
       Only the display changes; the form still sends the quantity and the cart prices it. */
    updatePrices(quantity) {
      const format = this.dataset.moneyFormat;

      if (!format) return;

      this.querySelectorAll('[data-unit-price]').forEach((price) => {
        price.textContent = ProductPurchase.formatMoney(Number(price.dataset.unitPrice) * Number(quantity), format);
      });
    }

    /* Same output as Liquid's `money` filter for the shop money format */
    static formatMoney(cents, format) {
      const placeholder = /\{\{\s*(\w+)\s*\}\}/;
      const amount = (decimals, thousands, separator) => {
        const [units, fraction] = (cents / 100).toFixed(decimals).split('.');
        const grouped = units.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

        return fraction ? grouped + separator + fraction : grouped;
      };
      const match = format.match(placeholder);
      let value;

      switch (match ? match[1] : 'amount') {
        case 'amount_no_decimals':
          value = amount(0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = amount(2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = amount(0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = amount(2, "'", '.');
          break;
        case 'amount_with_space_separator':
          value = amount(2, ' ', ',');
          break;
        default:
          value = amount(2, ',', '.');
      }

      return format.replace(placeholder, value);
    }

    update() {
      const checked = this.querySelector('input[name="purchase_option"]:checked');
      const option = checked ? checked.value : 'subscription';
      const sellingPlanInput = this.querySelector('[data-selling-plan-input]');

      this.dataset.purchaseOption = option;

      if (sellingPlanInput) {
        sellingPlanInput.disabled = option !== 'subscription';
      }
    }
  }

  if (!customElements.get('product-purchase')) {
    customElements.define('product-purchase', ProductPurchase);
  }

  class QuantitySelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      this.value = this.querySelector('[data-quantity-value]');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');

        if (!button || !this.contains(button)) return;

        this.setQuantity(Number(this.input.value) + Number(button.dataset.quantityStep));
      });
    }

    setQuantity(quantity) {
      const next = Math.min(99, Math.max(1, quantity));

      this.input.value = next;
      this.value.textContent = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-selector')) {
    customElements.define('quantity-selector', QuantitySelector);
  }

  class FloatingCta extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.shopify-section');

      this.target = section ? section.querySelector('.pack-hero__submit') : null;

      if (!this.target) return;

      this.observer = new IntersectionObserver(() => this.sync());
      this.observer.observe(this.target);

      this.onScroll = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.sync(), 120);
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.sync();

      const form = document.getElementById(this.dataset.form);
      const badge = this.querySelector('[data-floating-quantity]');
      const quantity = form ? form.querySelector('[data-quantity-input]') : null;

      if (quantity && badge) {
        this.onQuantity = () => {
          badge.textContent = quantity.value;
        };
        quantity.addEventListener('change', this.onQuantity);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();

      window.removeEventListener('scroll', this.onScroll);
      clearTimeout(this.timer);
    }

    sync() {
      const passed = this.target.getBoundingClientRect().bottom <= 0;

      this.classList.toggle('is-visible', passed);
      this.inert = !passed;
    }
  }

  if (!customElements.get('floating-cta')) {
    customElements.define('floating-cta', FloatingCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-menu"]) return;
  try {
    
  class MobileMenu extends HTMLElement {
    connectedCallback() {
      this.whenReady(() => this.init());
    }

    whenReady(callback) {
      const attempt = () => {
        if (window.BarkitaDrawer && document.readyState !== 'loading') {
          callback();

          return true;
        }

        return false;
      };

      if (attempt()) return;

      document.addEventListener('barkita-drawer:ready', attempt);
      document.addEventListener('DOMContentLoaded', attempt);
    }

    init() {
      if (this.drawer) return;

      this.drawer = new window.BarkitaDrawer(this, {
        lockClass: 'mobile-menu-open',
        onOpen: () => this.setExpanded(true),
        onClose: () => this.setExpanded(false)
      });

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-menu-open]');

        if (!trigger) return;

        event.preventDefault();
        this.drawer.open(trigger);
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) this.drawer.close();
      });
    }

    setExpanded(expanded) {
      document.querySelectorAll('[data-menu-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(expanded));
      });
    }
  }

  if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"] && !Shopify.designMode) return;
  try {
    
  class UgcMedia extends HTMLElement {
    connectedCallback() {
      const play = this.querySelector('[data-play]');
      const wrapper = this.querySelector('[data-video]');
      const video = wrapper ? wrapper.querySelector('video') : null;

      if (!play || !video) return;

      play.addEventListener('click', () => {
        wrapper.hidden = false;
        play.hidden = true;
        video.play();
      });

      video.addEventListener('ended', () => {
        wrapper.hidden = true;
        play.hidden = false;
      });
    }
  }

  if (!customElements.get('ugc-media')) {
    customElements.define('ugc-media', UgcMedia);
  }

  } catch(e) { console.error(e); }
})();
})();
